// client/src/coms/views/studio_parts/StudioView.js
import React from 'react';

export default function StudioView() {
  return (
    <div className="coms-view">
      <div
        style={{
          minHeight: 'calc(100vh - 180px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 24,
          boxSizing: 'border-box',
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: 760,
            borderRadius: 20,
            border: '1px solid rgba(255,255,255,0.08)',
            background: 'rgba(255,255,255,0.035)',
            boxShadow: '0 18px 50px rgba(0,0,0,0.28)',
            padding: 32,
            textAlign: 'center',
          }}
        >
          <div
            style={{
              fontSize: 30,
              fontWeight: 900,
              lineHeight: 1.1,
              color: 'rgba(255,255,255,0.98)',
              marginBottom: 12,
            }}
          >
            Studio
          </div>

          <div
            style={{
              fontSize: 16,
              lineHeight: 1.6,
              color: 'rgba(255,255,255,0.78)',
              maxWidth: 560,
              margin: '0 auto 18px',
            }}
          >
            Coming soon.
          </div>

          <div
            style={{
              fontSize: 14,
              lineHeight: 1.7,
              color: 'rgba(255,255,255,0.58)',
              maxWidth: 620,
              margin: '0 auto',
            }}
          >
            Studio will be a real-time collaborative space where musicians create, share, and perform music together.
          </div>
        </div>
      </div>
    </div>
  );
}
